import type { PublicacionCreada, PublicacionCrearInput, PublicacionPublic } from '@app/shared';

import { api } from '../../../lib/api';

// El Publicador (ciclo-panel): multipart con los campos + los archivos en orden.
// FormData no manda arrays: `redes` viaja como "INSTAGRAM,TIKTOK" y el backend lo parte.
export const publicacionesApi = {
  async crear(
    input: PublicacionCrearInput,
    archivos: File[],
    onProgreso?: (pct: number) => void,
  ): Promise<PublicacionCreada> {
    const fd = new FormData();
    fd.append('titulo', input.titulo);
    fd.append('caption', input.caption ?? '');
    fd.append('hashtags', input.hashtags ?? '');
    fd.append('formato', input.formato);
    fd.append('redes', input.redes.join(','));
    fd.append('pilar', input.pilar ?? '');
    fd.append('modo', input.modo);
    fd.append('fecha', input.fecha ?? '');
    fd.append('hora', input.hora ?? '13:00');
    fd.append('notas', input.notas ?? '');
    for (const a of archivos) fd.append('archivos', a, a.name);
    const { data } = await api.post<PublicacionCreada>('/publicaciones', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      // Un video de 95 MB con una conexión lenta tarda: no usar el timeout general.
      timeout: 10 * 60 * 1000,
      onUploadProgress: (e) => {
        if (onProgreso && e.total) onProgreso(Math.round((e.loaded / e.total) * 100));
      },
    });
    return data;
  },

  async listar(
    params: { desde?: string; hasta?: string; limite?: number } = {},
  ): Promise<PublicacionPublic[]> {
    const { data } = await api.get<PublicacionPublic[]>('/publicaciones', { params });
    return data;
  },
};
